import actionCreator from '../../createAction';

const createAction = actionCreator('dcc');

export const FETCH_DCC = createAction('FETCH_DCC');

export const GET_CONTACT = createAction('GET_CONTACT');
